import "./ProdutosMarcas.css";

export default function ProdutosMarcas({ dados }) {
  if (!dados) return null;

  return (
    <section className="produtos-marcas">
      {/* Banner superior */}
      <div className="produtos-marcas-banner">
        <img
          src={dados.banner3} // banner3
          alt="Banner Produtos"
        />
      </div>

      {/* Produtos */}
      <div className="produtos-marcas-grid">
        <div className="produto-marca-card">
          <img src={dados.prod1} alt="Produto 1" /> 
        </div>

        <div className="produto-marca-card">
          <img src={dados.prod2} alt="Produto 2" /> 
        </div>

        <div className="produto-marca-card">
          <img src={dados.prod3} alt="Produto 3" /> 
        </div>

        <div className="produto-marca-card">
          <img src={dados.prod4} alt="Produto 4" /> 
        </div>
      </div>

      <div className="produtos-marcas-grid margin-to-top">
        <div className="produto-marca-card-banner">
          <img src={dados.banner4} alt="Banner inferior" /> 
        </div>

        <div className="produto-marca-card-prod">
          <img src={dados.prod5} alt="Produto 5" /> 
        </div>

        <div className="produto-marca-card-prod">
          <img src={dados.prod6} alt="Produto 6" /> 
        </div>
      </div>
    </section>
  );
}
